const BaseComponent = require('base/base-component');

class investmentFooter extends BaseComponent{
    constructor() {
        super()
      }
      init(){
        const governmentWebsite = [
          {name:"市文广新局",url:"http://www.wzwh.com/"},
          {name:"市商务局",url:"http://ftec.wenzhou.gov.cn"},
          {name:"市水利局",url:"http://www.wzsl.gov.cn/"},
          {name:"市住建委",url:"http://wzszjw.wenzhou.gov.cn/"},
          {name:"市规划局",url:"http://wzup.wenzhou.gov.cn/"},
          {name:"市国土资源局",url:"http://www.wzgt.gov.cn/"},
          {name:"市人力社保局",url:"http://www.wzhrss.gov.cn"},
          {name:"市财政局",url:"http://czj.wenzhou.gov.cn/"},
          {name:"市司法局",url:"http://www.sifa.gov.cn/"},
          {name:"市监察局",url:"http://www.wzlzw.gov.cn"},
          {name:"市公安局",url:"http://www.wzga.gov.cn/"},
          {name:"市科学技术局",url:"http://www.wzinfo.net.cn/"},
          {name:"市教育局",url:"http://edu.wenzhou.gov.cn/"},
        ];
        const regulatoryEnterprise = [
          {name:"温州设计集团",url:"http://www.wzadri.com/"},
          {name:"温州银行",url:"http://www.wzcb.com.cn/index.php/home"},
          {name:"温州建设集团有限公司",url:"http://www.wzjsjt.com/"},
          {name:"温州公用集团",url:"http://www.wzgytz.com/"},
          {name:"温州交运集团",url:"http://www.wzsjy.com"},
          {name:"温州市交通投资集团有限公司",url:"http://www.wzjtjt.cn/"},
          {name:"温州市现代服务业投资集团有限公司",url:"http://wzmodern.com.cn/"},
          {name:"温州市工业投资集团",url:"http://www.wzgyjt.com/public/"},
          {name:"温州机场集团",url:"http://www.wzair.cn/"},
          {name:"温州市农投集团",url:"http://www.wzntjt.com/public/"},
          {name:"温州名城集团",url:"http://www.wzmingcheng.com/"},
          {name:"温州金融投资集团",url:"http://www.wzjrtzjt.com"},
        ];
        const recommendedWebsite = [
          {name:"中国温州",url:"http://www.wenzhou.gov.cn/"},
          {name:"温州图书馆",url:"http://www.wzlib.cn/"},
          {name:"温州市民卡",url:"http://www.wz96225.com/"},
          {name:"温州农村产权交易平台",url:"http://www.wznccq.com/"},
        ];
        const friendshipLink = [
          {name:"中国政府采购",url:"http://www.ccgp.gov.cn/"},
          {name:"中国采购与招标网",url:"http://www.chinabidding.com.cn/"},
          {name:"浙江政府采购",url:"http://zfcg.czt.zj.gov.cn/new/"},
          {name:"浙江重大工程交易网",url:"http://www.zmctc.com/zjgcjy/"},
          {name:"浙江产权交易信息网",url:"http://www.zjpse.com/"},
          {name:"温州市公共资源交易网",url:"http://www.wzzbtb.com/homepage/"},
        ];
        const webArr = [governmentWebsite,regulatoryEnterprise,recommendedWebsite,friendshipLink]
        const lis = this.$el.find('.footer-header-ul>li');
        if(lis.length>0){
          $.each(lis,(index,item)=>{
            const web = webArr[index];
            let htmlTemp = `<div  class='webList'><ul>`;
            for (var i = 0; i < web.length; i++) {
                htmlTemp += "<li><a href="+ web[i].url + " target='_blank'>" + web[i].name + "</a></li>";
            }
            htmlTemp += "</ul></div>";
            $(item).append($(htmlTemp))
          })
          this.$el.find('.footer-header-ul li').on('click', (e) => {
            this.$el.find('.footer-header-ul li .webList').removeClass('add');
            $(e.target).find('.webList').addClass('add');
          })
          $(document).on('click', (e) => {
            !$(e.target).hasClass('list_foot_info') && this.$el.find('.footer-header-ul li').find('.webList').removeClass('add');
          })
        }
      }
}
module.exports = investmentFooter;
